const STALE_ASSET_RELOAD_KEY = 'coolbuy:stale-asset-reload-at';
const STALE_ASSET_RELOAD_COOLDOWN_MS = 30_000;

const STALE_ASSET_PATTERNS = [
  /Unable to preload CSS/i,
  /Failed to fetch dynamically imported module/i,
  /error loading dynamically imported module/i,
  /Importing a module script failed/i,
  /ChunkLoadError/i,
  /Loading chunk \d+ failed/i,
  // Stale cached chunk: old bundle defines no `default` export; React.lazy throws this
  // instead of a network error when the chunk file itself still loads but is outdated.
  /Cannot read properties of undefined \(reading 'default'\)/i,
];

const getMessage = (reason: unknown): string => {
  if (reason instanceof Error) return reason.message;
  if (typeof reason === 'string') return reason;
  if (reason && typeof reason === 'object' && 'message' in reason) {
    return String((reason as { message?: unknown }).message ?? '');
  }
  return String(reason ?? '');
};

export const isStaleAssetError = (reason: unknown): boolean => {
  const message = getMessage(reason);
  return STALE_ASSET_PATTERNS.some((pattern) => pattern.test(message));
};

const shouldReload = (now: number): boolean => {
  const lastReload = Number(window.sessionStorage.getItem(STALE_ASSET_RELOAD_KEY) || 0);
  return !Number.isFinite(lastReload) || now - lastReload > STALE_ASSET_RELOAD_COOLDOWN_MS;
};

export const reloadForFreshAssets = (): void => {
  const now = Date.now();
  if (!shouldReload(now)) return;

  window.sessionStorage.setItem(STALE_ASSET_RELOAD_KEY, String(now));
  window.location.reload();
};

export const installStaleAssetReload = (): void => {
  if (typeof window === 'undefined') return;

  // Vite 5: fires before the dynamic import promise rejects, before React ErrorBoundary
  window.addEventListener('vite:preloadError', (event) => {
    event.preventDefault();
    reloadForFreshAssets();
  });

  window.addEventListener('error', (event) => {
    if (isStaleAssetError(event.error || event.message)) {
      event.preventDefault();
      reloadForFreshAssets();
    }
  });

  window.addEventListener('unhandledrejection', (event) => {
    if (isStaleAssetError(event.reason)) {
      event.preventDefault();
      reloadForFreshAssets();
    }
  });
};
